import { basenameForTeamsApp } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';
import { useHistory } from 'react-router';

import { useTeamsCachedAppSwitchContext } from './selectors';

const getTargetUrl = (contentUrl: string) => {
  const pathname = new URL(contentUrl).pathname;

  return pathname.replace(new RegExp(`^${basenameForTeamsApp}`), '');
};

type UseHandleOnLoadCachedApp = () => void;
export const useHandleOnLoadCachedApp: UseHandleOnLoadCachedApp = () => {
  const history = useHistory();
  const appSwitchContext = useTeamsCachedAppSwitchContext();

  const switchedContentUrl = appSwitchContext?.switchedContentUrl;
  const deepLinkPath = appSwitchContext?.deepLinkPath;

  useEffect(() => {
    if (!switchedContentUrl || deepLinkPath) {
      return;
    }

    const targetUrl = getTargetUrl(switchedContentUrl);
    history.replace(`${targetUrl}`);
  }, [switchedContentUrl, deepLinkPath, history]);
};
